export enum InvoiceStatusEnum {
  Draft = 'Draft',
  Active = 'Active',
  Seen = 'Seen',
  Sent = 'Sent',
  Paid = 'Paid',
  Overdue = 'Overdue',
  PartiallyPaid = 'Partially Paid',
  InActive = 'In Active',
}
